module.exports = {
  backStackRoutes: [
    {
      path: '/backStackSupport',
      name: 'backStackSupport',
      component: () => import('@/views/backstageSupport'),
      meta: {
        title: '后台',
      },
      children: [
        {
          path: '/account/infos',
          name: 'accountInfos',
          component: () =>
            import('@/views/backstageSupport/pages/AccountInfos'),
          meta: {
            title: '账户信息,基础信息',
          },
        },
        {
          path: '/demand/info',
          name: 'demandInfos',
          component: () => import('@/views/backstageSupport/pages/DemandInfos'),
          meta: {
            title: '需求管理,需求信息',
          },
        },
        {
          path: '/demand/issue',
          name: 'demandIssue',
          component: () => import('@/views/backstageSupport/pages/DemandIssue'),
          meta: {
            title: '需求管理,发布需求',
          },
        },
        {
          path: '/licence/infos',
          name: 'licenceInfos',
          component: () =>
            import('@/views/backstageSupport/pages/LicenceInfos'),
          meta: {
            title: '开放许可管理,开放许可信息',
          },
        },
        {
          path: '/licence/issue',
          name: 'licenceIssue',
          component: () =>
            import('@/views/backstageSupport/pages/LicenceIssue'),
          meta: {
            title: '开放许可管理,发布开放许可信息',
          },
        },
        {
          path: '/operation/infos',
          name: 'operationInfos',
          component: () =>
            import('@/views/backstageSupport/pages/OperationInfos'),
          meta: {
            title: '运营管理,运营信息',
          },
        },
        {
          path: '/operation/issue',
          name: 'operationIssue',
          component: () =>
            import('@/views/backstageSupport/pages/OperationIssue'),
          meta: {
            title: '运营管理,发布运营信息',
          },
        },
        {
          path: '/server/addfinance',
          name: 'ServerFinanceCreate',
          component: () =>
            import('@/views/backstageSupport/pages/ServerFinanceCreate'),
          meta: {
            title: '编辑金融服务',
          },
        },
        {
          path: '/server/finance',
          name: 'serverInfos',
          component: () =>
            import('@/views/backstageSupport/pages/ServerFinance'),
          meta: {
            title: '金融服务管理',
          },
        },
        {
          path: '/server/infos',
          name: 'infosManage',
          component: () => import('@/views/backstageSupport/pages/ServerInfos'),
          meta: {
            title: '服务信息管理',
          },
        },
        {
          path: '/server/addinfos',
          name: 'ServerInfosCreate',
          component: () =>
            import('@/views/backstageSupport/pages/ServerInfosCreate'),
          meta: {
            title: '编辑服务信息',
          },
        },
        {
          path: '/supervise/infos',
          name: 'superviseInfos',
          component: () =>
            import('@/views/backstageSupport/pages/SuperviseInfos'),
          meta: {
            title: '企业监控信息',
          },
        },
        {
          path: '/information/infos',
          name: 'informationInfos',
          component: () =>
            import('@/views/backstageSupport/pages/InformationInfos'),
          meta: {
            title: '综合信息管理',
          },
        },
        // {
        //   path: '/information/infos/operation',
        //   name: 'informationInfosOperation',
        //   component: () =>
        //     import('@/views/backstageSupport/pages/informationInfosOperation'),
        //   meta: {
        //     title: '编辑综合信息'
        //   }
        // },
        {
          path: '/information/create',
          name: 'informationCreate',
          component: () =>
            import('@/views/backstageSupport/pages/InformationCreate'),
          meta: {
            title: '新增综合信息',
          },
        },
        {
          path: '/informationAnnouncement',
          name: 'informationAnnounce',
          component: () =>
            import('@/views/backstageSupport/pages/InformationAnnounce'),
          meta: {
            title: '产业信息服务管理',
          },
        },
        {
          path: '/informationAnnouncement/operation',
          name: 'informationOperation',
          component: () =>
            import(
              '@/views/backstageSupport/pages/InformationAnnounceOperation'
            ),
          meta: {
            title: '产业信息服务管理操作',
          },
        },
        {
          path: '/InnovationSubject',
          name: 'innovationSubject',
          component: () =>
            import('@/views/backstageSupport/pages/InnovationSubject'),
          meta: {
            title: '创新主体管理',
          },
        },
        {
          path: '/InnovationSubject/operation',
          name: 'innovationSubjectOperation',
          component: () =>
            import('@/views/backstageSupport/pages/InnovationSubjectOperation'),
          meta: {
            title: '创新主体',
          },
        },
        {
          path: '/content/demand',
          name: 'contentDemand',
          component: () =>
            import('@/views/backstageSupport/pages/ContentDemand'),
          meta: {
            title: '需求审核',
          },
        },
        {
          path: '/content/operation',
          name: 'contentOperation',
          component: () =>
            import('@/views/backstageSupport/pages/ContentOperation'),
          meta: {
            title: '运营信息审核',
          },
        },
        {
          path: '/content/licence',
          name: 'contentLicence',
          component: () =>
            import('@/views/backstageSupport/pages/ContentLicence'),
          meta: {
            title: '开放许可信息审核',
          },
        },
        {
          path: '/content/server',
          name: 'contentServer',
          component: () =>
            import('@/views/backstageSupport/pages/ContentServer'),
          meta: {
            title: '服务信息审核',
          },
        },
        {
          path: '/talents/infos',
          name: 'talentsInfos',
          component: () =>
            import('@/views/backstageSupport/pages/TalentsInfos'),
          meta: {
            title: '人才管理,人才管理信息',
          },
        },
        {
          path: '/talents/operation',
          name: 'talentsOperation',
          component: () =>
            import('@/views/backstageSupport/pages/TalentsOperation'),
          meta: {
            title: '人才管理,人才管理操作',
          },
        },
        {
          path: '/talents/techTeam',
          name: 'techTeam',
          component: () => import('@/views/backstageSupport/pages/techTeam'),
          meta: {
            title: '人才管理,技术团队管理',
          },
        },
        {
          path: '/talents/techTeamOperation',
          name: 'techTeamOperation',
          component: () =>
            import('@/views/backstageSupport/pages/techTeamOperation'),
          meta: {
            title: '人才管理,技术团队操作',
          },
        },
        {
          path: '/favorite/my',
          name: 'favoriteMy',
          component: () => import('@/views/backstageSupport/pages/FavoriteMy'),
          meta: {
            title: '我的收藏',
          },
        },
        {
          path: '/system/user',
          name: 'systemUser',
          component: () => import('@/views/backstageSupport/pages/SystemUser'),
          meta: {
            title: '用户管理',
          },
        },
        {
          path: '/system/log',
          name: 'systemLog',
          component: () => import('@/views/backstageSupport/pages/SystemLog'),
          meta: {
            title: '日志管理',
          },
        },
        {
          path: '/system/userStatistics',
          name: 'userStatistics',
          component: () =>
            import('@/views/backstageSupport/pages/UserStatistics'),
          meta: {
            title: '用户统计',
          },
        },
        {
          path: '/system/messageStatistic',
          name: 'messageStatistic',
          component: () =>
            import('@/views/backstageSupport/pages/MessageStatistic'),
          meta: {
            title: '信息发布统计',
          },
        },
      ],
    },
  ],
};
